import axios from 'axios';
import { cacheBuster } from '@/common/helpers';

export function getNotifications(force: boolean) {
  return axios.get(`/get/notification?new${cacheBuster(force)}`).then((value: any) => value);
}
